module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('div', {
    staticClass: "title",
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "z-index": "999",
      "width": "7.5rem"
    }
  }, [(_vm.$route.query.sourceflag != 'app') ? _c('pageTitle', {
    attrs: {
      "title": "附近酒店"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapA"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be48ccdc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/nearbyHotels.vue
// module id = 1585
// module chunks = 18